import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  Container,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {
  getDailyFundPortfolioByDate,
  addDailyFundortfolio,
  saveDailyFundportfolio,
} from "../../stores/services/daily-fund-portfolio.service";
import { AiFillPlusCircle } from "react-icons/ai";
import { BsTable } from "react-icons/bs";
import moment from "moment";
import { numberWithCommas } from "../../utils/customFunction";
import { useSelector } from "react-redux";
import { getFundByAmc } from "../../stores/services/funds.service";
import TableHeading from "../../components/ui/TableHeading";
import {
  moneymarketPortfolioHeadings,
  stockmarketPortfolioHeadings,
} from "../../utils/ui_data";

const DailyFundPortfolio = () => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  let date = new Date();
  const email = sessionStorage.getItem("email") || "";
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const [Loading, setLoading] = useState(false);
  const [createdDate, setCreatedDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );
  const [settlementDate, setSettlementDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );
  const [dailPortfolio, setDailyPortfolio] = useState<any>([]);
  const history = useHistory();
  // modals
  const [viewMoneyMaketModal, setViewMoneyMarketModal] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [viewStockMarketModal, setViewStockMarketModal] = useState(false);
  const [saveDailyFundModal, setSaveDailyFundModal] = useState(false);
  const [moneyMarketPortfolio, setMoneyMarketPortfolio] = useState<any>([]);
  const [stockMarketPortfolio, setStockMarketPortfolio] = useState<any>([]);
  const [saveDailyFundPortfolioLoading, setDailyFundPortfolioLoading] =
    useState(false);
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [funds, setFunds] = useState<any>([]);
  const [tempFunds, setTempFunds] = useState<any>([]);
  const [errorFunds, setErrorFunds] = useState<any>([]);
  const [loadingFunds, setLoadingFunds] = useState(false);
  const [loadingSaveFundPortfolio, setLoadingSaveFundPortfolio] =
    useState(false);

  React.useEffect(() => {
    getDailyPortfolioByDate();
  }, []);

  const getDailyPortfolioByDate = async () => {
    setLoading(true);
    dailPortfolio.length = 0;
    setDailyPortfolio(dailPortfolio);
    try {
      const response = await getDailyFundPortfolioByDate(
        email,
        amcCode,
        createdDate
      );
      if (response.data.status == 200) {
        setDailyPortfolio(response.data.data);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
    setLoading(false);
  };

  const addFundPortfolio = async () => {
    setDailyFundPortfolioLoading(true);
    try {
      const response = await addDailyFundortfolio(email, amcCode);
      if (response.data.status == 200) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
      setDailyFundPortfolioLoading(false);
    } catch (err: any) {
      setDailyFundPortfolioLoading(false);
    }
    setDailyFundPortfolioLoading(false);
  };

  const decimalValue = (value, len) => {
    if (value === 0 || value === parseInt(value, 10)) return value;
    value = value.toString();
    let startingValue = value.split(".")[0];
    let decimalVal = value.split(".")[1];
    let temp = "";
    if (decimalVal !== undefined) {
      let decimalString = decimalVal.toString();
      if (decimalString.length <= len) {
        temp = startingValue + "." + decimalString;
      } else {
        temp = startingValue + "." + decimalString.substr(0, len);
      }
    } else {
      temp = startingValue;
    }
    return temp;
  };

  const renderData = () => {
    return dailPortfolio.map((items: any, index: any) => {
      return (
        <tr key={index}>
          <td>{items.fund_code}</td>
          <td>
            <div
              className="fa fa-eye text-primary pointer"
              onClick={() => {
                moneyMarketPortfolio.length = 0;
                setMoneyMarketPortfolio(moneyMarketPortfolio);

                setMoneyMarketPortfolio(JSON.parse(items.money_market));
                setViewMoneyMarketModal(true);
              }}
            ></div>
          </td>
          <td>
            <div
              className="fa fa-eye text-primary pointer"
              onClick={() => {
                stockMarketPortfolio.length = 0;
                setStockMarketPortfolio(stockMarketPortfolio);

                setStockMarketPortfolio(JSON.parse(items.stock_market));
                setViewStockMarketModal(true);
              }}
            ></div>
          </td>
        </tr>
      );
    });
  };

  const renderData1 = () => {
    return funds?.map((items: any, index: any) => {
      return (
        <tr
          style={{
            backgroundColor:
              errorFunds?.length > 0 &&
                errorFunds?.filter((ele) => ele?.fund_code == items?.symbol_code)
                  ?.length > 0
                ? "#8b0000"
                : "",
          }}
        >
          <td
            style={{
              width: "25%",
            }}
          >
            <div className="d-flex align-items-center">
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={items?.checked}
                    onChange={() => {
                      const updatedFunds = [...funds];
                      updatedFunds[index].checked = !items.checked;
                      setFunds(updatedFunds);
                    }}
                  />
                  <span className="form-check-sign" />
                </Label>
              </FormGroup>
              <div className="ml-2">{items?.symbol_code}</div>
            </div>
          </td>
          <td>
            {errorFunds?.length > 0 &&
              errorFunds?.filter((ele) => ele?.fund_code == items?.symbol_code)
                ?.length > 0 &&
              errorFunds?.find(
                (ele) => ele?.fund_code == items?.symbol_code
              )?.message
            }
          </td>
        </tr>
      );
    });
  };

  // render Money Market Portfolio
  const renderMoneyMarketModalPopup = () => {
    switch (viewMoneyMaketModal) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="xl"
            backdrop={true}
            onHide={() => {
              setViewMoneyMarketModal(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setViewMoneyMarketModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up"> Money Market Portfolio </h6>
            </div>

            <div className="modal-body">
              <div className="table-responsive">
                {moneyMarketPortfolio.length > 0 ? (
                  <div className="input-size-pos mb-3 mt-2">
                    {/* <h3>Money Market Portfolio</h3> */}
                    <table className="table   ">
                      <TableHeading headings={moneymarketPortfolioHeadings} />
                      {/* <thead>
                        <tr>
                          <th>Symbol</th>
                          <th>Security Type</th>
                          <th>Name</th>
                          <th>Issue Date</th>
                          <th>Maturity Date</th>
                          <th>Coupon Rate %</th>
                          <th>Yield %</th>
                          <th>Money Market Face Value/Unit</th>
                          <th>Total Face Value</th>
                          <th>Units</th>
                          <th>Avg Cost/Unit</th>
                          <th>Total Cost / Amount</th>
                          <th>Market Rate/Unit</th>
                          <th>Market Value</th>
                          <th>Unrealized Gain/(Loss)</th>
                          <th>Investment as % of Market Value</th>
                        </tr>
                      </thead> */}
                      <tbody>{renderMoneyMarketPortfolioDataInTable()}</tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center">
                    No Money Market Portfolio Found
                  </div>
                )}
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  const renderMoneyMarketPortfolioDataInTable = () => {
    const moneyMarketFiltered = moneyMarketPortfolio?.filter((ele) => {
      if ((ele?.security_type === "CP" || ele?.security_type === "TDR" || ele?.security_type === "CDR" || ele?.security_type === "LOP") && ele?.principal_amount > 0) {
        return true
      }
      else if (ele?.units > 0) {
        return true
      }
      else {
        return false
      }
    })
    return moneyMarketFiltered?.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items?.code}</td>
          <td>{items?.security_type}</td>
          <td>{items?.name}</td>
          <td>{items?.issue_date}</td>
          <td>{items?.maturity_date}</td>
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.coupon_rate || 0)?.toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.yield || 0)?.toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.mmface_value || 0)?.toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(
              parseFloat(items?.total_face_value || 0)?.toFixed(4)
            )}
          </td>
          {/* <td>{numberWithCommas(items.price || '')}</td> */}
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.units || 0)?.toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(
              parseFloat(items?.average_cost_per_unit || 0)?.toFixed(4)
            )}
          </td>
          <td className="text-right">
            {" "}
            {numberWithCommas(
              parseFloat(items?.total_amount || 0).toFixed(4)
            )}{" "}
          </td>
          <td className="text-right">
            {" "}
            {numberWithCommas(
              parseFloat(items?.market_rate_per_unit || 0)?.toFixed(4)
            )}{" "}
          </td>
          <td className="text-right">
            {" "}
            {numberWithCommas(
              parseFloat(items?.market_value || 0)?.toFixed(4)
            )}{" "}
          </td>
          <td className="text-right">
            {" "}
            {numberWithCommas(
              parseFloat(items?.unrealized_gain_loss || 0)?.toFixed(4)
            )}{" "}
          </td>
          <td className="text-right">
            {" "}
            {numberWithCommas(
              parseFloat(
                items?.investment_percentage_market_value || 0
              )?.toFixed(4)
            )}{" "}
          </td>
        </tr>
      );
    });
  };

  // render Stock Market Portfolio
  const renderStockMarketPortfolioModal = () => {
    switch (viewStockMarketModal) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            onHide={() => {
              setViewStockMarketModal(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setViewStockMarketModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up"> Stock Market Portfolio </h6>
            </div>

            <div className="modal-body ">
              <div className="table-responsive">
                {stockMarketPortfolio.length > 0 ? (
                  <div className="input-size-pos mb-3 mt-2 ">
                    {/* <h3>Stock Market Portfolio</h3> */}
                    <table className="table">
                      <TableHeading headings={stockmarketPortfolioHeadings} />
                      {/* <thead>
                        <tr>
                          <th>Symbol</th>
                          <th>Market</th>
                          <th>Total Units</th>
                          <th>Available Units</th>
                          <th>Average Cost / Unit</th>
                          <th>Total Cost / Amount</th>
                          <th>Market Rate/Unit</th>
                          <th>Market Value</th>
                          <th>Unrealzed Gain/(Loss)</th>
                          <th>Investment as % Market Value</th>
                        </tr>
                      </thead> */}
                      <tbody>{renderStockMarketPortfolioInTable()}</tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center">
                    No Stock Market Portfolio Found
                  </div>
                )}
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  //render equity table data
  const renderStockMarketPortfolioInTable = () => {
    return stockMarketPortfolio.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.code}</td>
          <td>{items.market}</td>
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.total_units || 0)?.toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.unit || 0)?.toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(
              parseFloat(items?.average_cost_per_unit || 0)?.toFixed(4)
            )}
          </td>
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.amount).toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(
              parseFloat(items?.market_rate_per_unit || 0)?.toFixed(4)
            )}
          </td>
          <td className="text-right">
            {numberWithCommas(parseFloat(items?.market_value || 0)?.toFixed(4))}
          </td>
          <td className="text-right">
            {numberWithCommas(
              parseFloat(items?.unrealized_gain_loss || 0)?.toFixed(4)
            )}
          </td>
          <td className="text-right">
            {numberWithCommas(
              parseFloat(
                items?.investment_percentage_market_value || 0
              )?.toFixed(4)
            )}
          </td>
        </tr>
      );
    });
  };

  const getFundsByAmcCode = async () => {
    setLoadingFunds(true);
    try {
      const response = await getFundByAmc(email, amc_code, "");
      let sortedData: any = [];
      let temp: any;
      const onlyActiveFunds = response?.data?.data?.filter(
        (ele) => ele?.status == "active"
      );
      temp = onlyActiveFunds?.map((ele) => {
        return {
          ...ele,
          checked: true,
        };
      });
      sortedData = temp?.sort(function (a, b) {
        let x = a?.nature?.toLowerCase();
        let y = b?.nature?.toLowerCase();
        if (x > y) {
          return 1;
        }
        if (x < y) {
          return -1;
        }
        return 0;
      });
      setFunds(sortedData);
      setTempFunds(sortedData);
    } catch (error) {
    } finally {
      setLoadingFunds(false);
    }
  };

  const handleSaveDailyFundPortfolio = async () => {
    let tempArr: any = [];
    // tempArr = funds?.filter((ele) => ele?.checked === true)?.map(({ checked, ...rest }) => rest)
    tempArr = funds?.filter((ele) => ele?.checked === true);
    const fundCodes =
      tempArr.length > 0
        ? tempArr?.map((obj) => obj?.symbol_code).join(",")
        : "";

    if (settlementDate === "") {
      toast.error("Settlement Date should not be empty");
      return;
    }

    if (fundCodes === "") {
      toast.error("Fund should not be empty");
      return;
    }

    try {
      setLoadingSaveFundPortfolio(true);
      let res = await saveDailyFundportfolio(
        email,
        amc_code,
        fundCodes,
        settlementDate || ""
      );
      if (res.status === 200 && res.data.status === 200) {
        toast.success(res.data.message);
        setFunds([]);
        setErrorFunds([]);
        setSettlementDate(moment()?.format("YYYY-MM-DD"));
        setTempFunds([])
        setSearchVal("");
        setSaveDailyFundModal(false);
      }
      if (res.status === 200 && res.data.status === 400) {
        setErrorFunds(res.data.fundList);
        toast.error(res.data.message);
      }
    } catch (error) {
    } finally {
      setLoadingSaveFundPortfolio(false);
    }
  };

  return (
    <>
      <div className="content">
        {/* ---------------- Modal Save Daily Fund Portfolio ------------ */}
        <Modal
          className=""
          dialogClassName="modal90w"
          show={saveDailyFundModal ? true : false}
          size="xl"
          backdrop={true}
          onHide={() => {
            setSaveDailyFundModal(false);
            setFunds([]);
            setTempFunds([])
            setErrorFunds([]);
            setSearchVal("")
            setSettlementDate(moment()?.format("YYYY-MM-DD"));
          }}
          centered={true}
        >
          <div className="modal-header ">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setSaveDailyFundModal(false);
                setFunds([]);
                setTempFunds([])
                setErrorFunds([]);
                setSearchVal("")
                setSettlementDate(moment()?.format("YYYY-MM-DD"));
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">Save Daily Fund Portfolio</h6>
          </div>
          <div className="modal-body">
            <div className="row align-items-center">
              <div className="col-md-5">
                <div className="form-group">
                  <label>Settlement Date:</label>
                  <input
                    style={{
                      colorScheme: theme == "light" ? "light" : "dark",
                    }}
                    type="date"
                    className="form-control"
                    value={settlementDate}
                    onChange={(e) => {
                      setSettlementDate(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <label></label>
                <button
                  className="btn btn-primary btn-block mt-0"
                  disabled={Boolean(Loading)}
                  onClick={() => {
                    setErrorFunds([]);
                    getFundsByAmcCode();
                  }}
                >
                  {Loading ? (
                    <>
                      <span
                        className="spinner-border login-txt spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="login-txt"> Loading...</span>
                    </>
                  ) : (
                    <span>Load</span>
                  )}
                </button>
              </div>
            </div>

            {loadingFunds || loadingSaveFundPortfolio ? (
              <div className="d-flex justify-content-center my-5">
                <i className="fa fa-spinner fa-spin fa-3x"></i>
              </div>
            ) : tempFunds?.length > 0 ? (
              <>
                <div className="d-flex align-items-center mb-1">
                  <FormGroup
                    style={{
                      minWidth: "fit-content"
                    }}
                    check>
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={funds?.length > 0 && funds?.every((ele) => ele?.checked == true)}
                        onChange={(e) => {
                          setSearchVal("")
                          if (e.target.checked) {
                            let temp = tempFunds?.map((ele) => {
                              return {
                                ...ele,
                                checked: true,
                              };
                            });
                            setFunds(temp);
                            setTempFunds(temp);
                          } else {
                            let temp = tempFunds?.map((ele) => {
                              return {
                                ...ele,
                                checked: false,
                              };
                            });
                            setFunds(temp);
                            setTempFunds(temp);
                          }
                        }}
                      />
                      <span className="form-check-sign" />
                      Select All
                    </Label>
                  </FormGroup>
                  <input
                    className="ml-2 form-control"
                    type="text"
                    style={{
                      maxWidth: "fit-content"
                    }}
                    placeholder="Search Fund"
                    value={searchVal}
                    onChange={(e) => {
                      setSearchVal(e?.target?.value)
                      if (e?.target?.value) {
                        let tempArr = [...tempFunds]
                        setFunds(
                          tempArr?.filter((item) =>
                            Object?.values(item)?.join(" ")?.toLowerCase()?.includes(e?.target?.value?.toLowerCase())
                          ))
                      }
                      else {
                        setFunds(tempFunds)
                      }
                    }}
                  />
                </div>
                <div
                  style={{
                    height: "40vh",
                    overflowY: "auto",
                  }}
                >
                  {funds?.length > 0 ?
                    <div className="table-responsive">
                      <table className="table" id="myTable">
                        <thead>
                          <tr>
                            <th
                              style={{
                                width: "5%",
                              }}
                            >
                              Fund
                            </th>
                            {errorFunds?.length > 0 &&
                              errorFunds?.filter((ele) =>
                                funds?.some(
                                  (ele1) => ele1?.symbol_code == ele?.fund_code
                                )
                              )?.length > 0 && <th>Reason</th>}
                          </tr>
                        </thead>
                        <tbody id="myUL">{renderData1()}</tbody>
                      </table>
                    </div> :
                    <div className="d-flex justify-content-center">
                      <b>No record found!</b>
                    </div>
                  }
                </div>
              </>
            ) : (
              <div className="table-empty">
                <BsTable className="icon" />
                <p
                  className={`text-center ${theme == "light" ? "text-dark" : "text-white"
                    }`}
                >
                  Empty
                </p>
              </div>
            )}
          </div>
          <div className="modal-footer p-3 d-flex justify-content-between">
            <Button
              onClick={() => {
                setFunds([]);
                setTempFunds([])
                setErrorFunds([]);
                setSearchVal("");
                setSettlementDate(moment()?.format("YYYY-MM-DD"));
                setSaveDailyFundModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={
                loadingSaveFundPortfolio ||
                (
                  funds?.every((ele) => ele?.checked == false) &&
                  settlementDate
                )
              }
              onClick={() => {
                handleSaveDailyFundPortfolio();
              }}
              color="primary"
            >
              Save Daily Fund Portfolio
            </Button>
          </div>
        </Modal>
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              {/* <Header /> */}

              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">
                    Daily Fund Portfolio
                    <button
                      className="btn btn-primary btn-sm float-right"
                      disabled={Boolean(saveDailyFundPortfolioLoading)}
                      onClick={() => {
                        setSaveDailyFundModal(true);
                        // addFundPortfolio();
                      }}
                    >
                      {saveDailyFundPortfolioLoading ? (
                        <>
                          <span
                            className="spinner-border login-txt spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span className="login-txt"> Loading...</span>
                        </>
                      ) : (
                        <span>Save Daily Fund Portfolio</span>
                      )}
                    </button>
                  </h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Date:</label>
                        <input
                          style={{
                            colorScheme: theme == "light" ? "light" : "dark",
                          }}
                          type="date"
                          className="form-control"
                          value={createdDate}
                          onChange={(e) => {
                            setCreatedDate(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <label></label>
                      <button
                        className="btn btn-primary btn-block"
                        disabled={Boolean(Loading)}
                        onClick={() => getDailyPortfolioByDate()}
                      >
                        {Loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Load</span>
                        )}
                      </button>
                    </div>
                  </div>

                  {Loading ? (
                    <div className="d-flex justify-content-center my-5">
                      <i className="fa fa-spinner fa-spin fa-3x"></i>
                    </div>
                  ) : dailPortfolio.length > 0 ? (
                    <>
                      <div className="table-responsive">
                        <table className="table" id="myTable">
                          <thead>
                            <tr>
                              <th>Fund</th>
                              <th>View Money Market Portfolio</th>
                              <th>View Stock Market Portfolio</th>
                            </tr>
                          </thead>
                          <tbody id="myUL">{renderData()}</tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <div className="table-empty">
                      <BsTable className="icon" />
                      <p className="text-center empty-text">Empty</p>
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </Col>
        </Row>
        {renderMoneyMarketModalPopup()}
        {renderStockMarketPortfolioModal()}
      </div>
    </>
  );
};

export default DailyFundPortfolio;
